import { NgModule } from '@angular/core';

import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import { SharedModule } from '../../../../shared';
import { CidadeModule } from '../../../cidade';
import { ClassificacaoFaturamentoMultiselectModule } from '../../../classificacao-faturamento/multiselect';
import { ClassificacaoTipoMultiselectModule } from '../../../classificacao/tipo/multiselect';
import { ClienteGrupoEconomicoMultiselectModule } from '../../../cliente-grupo-economico/multiselect';
import { ClienteGrupoMultiselectModule } from '../../../cliente-grupo/multiselect';
import { ClienteTipoMultiselectModule } from '../../../cliente-tipo/multiselect';
import { EstadoMultiselectModule } from '../../../estado/multiselect';
import { GrupoClassificacaoMultiselectModule } from '../../../grupo-classificacao/multiselect';
import { ItemTipoMultiselectModule } from '../../../item-tipo/multiselect';
import { MetaMultiselectModule } from '../../../meta/multiselect';
import { ClienteCadastroMultiselectModule } from '../../../pessoa/cliente/cadastro/multiselect';
import { ClienteSituacaoMultiselectModule } from '../../../pessoa/cliente/situacao/multiselect';
import { RepresentanteMultiselectModule } from '../../../pessoa/representante/multiselect';
import { CustomerShareIndicadorMultiselectModule } from '../../../pic/customer-share/indicador/multiselect';
import { UsuarioAtendenteMultiselectModule } from '../../../usuario/multiselect/atendente';
import { ClienteAnaliseMercadoStatusPretendidoModule } from '../../status-pretendido';
import { ClienteAnaliseMercadoStatusProjetadoModule } from '../../status-projetado';
import { ClienteAnaliseMercadoPeriodicidadeFilterModule } from '../periodicidade-filter';

import { ClienteAnaliseMercadoFilterComponent } from './cliente-analise-mercado-filter.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseMercadoPeriodicidadeFilterModule,
        ClienteAnaliseMercadoStatusPretendidoModule,
        ClienteAnaliseMercadoStatusProjetadoModule,
        ClassificacaoFaturamentoMultiselectModule,
        GrupoClassificacaoMultiselectModule,
        ClassificacaoTipoMultiselectModule,
        ClienteCadastroMultiselectModule,
        ClienteSituacaoMultiselectModule,
        MetaMultiselectModule,
        RepresentanteMultiselectModule,
        ClienteTipoMultiselectModule,
        ClienteGrupoMultiselectModule,
        ClienteGrupoEconomicoMultiselectModule,
        ItemTipoMultiselectModule,
        EstadoMultiselectModule,
        CidadeModule,
        CustomerShareIndicadorMultiselectModule,
        UsuarioAtendenteMultiselectModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        ClienteAnaliseMercadoFilterComponent
    ],
    exports: [
        ClienteAnaliseMercadoFilterComponent
    ]
})
export class ClienteAnaliseMercadoFilterModule { }
